export default __webpack_public_path__ + "static/media/jwt.8a766ec5.svg";